import React from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword: React.FC = () => {
  return (
    <div className="create-password-page js-pg-hg">
      <div className="container">
        <div className="row align-items-center justify-content-center my-5 py-3">
          <div className="col-xl-4 col-lg-6 col-md-8 col-sm-8 col-11 mt-5 mt-xl-0">
            <div className="card shadow-sm d-flex mt-5 mt-xl-0 bx-center border-0 p-4">
              <div className="card-body text-start">
                <form>
                  <h4>Set New Password</h4>
                  <label>
                  Your password must be 8 letters long, contain at least 1 uppercase letter, and have at least 1 number.
                  </label>
                  <div className="mt-4 text-start">

                    <div className="form-group mb-4">
                      <label htmlFor="password" className="form-label">
                        New Password <span className='red'>*</span>
                      </label>
                      <input
                        id="password"
                        className="form-control-custom"
                        type="password"
                        placeholder="Enter email address"
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label htmlFor="password" className="form-label">
                        Comfirm Password <span className='red'>*</span>
                      </label>
                      <input
                        id="password"
                        className="form-control-custom"
                        type="password"
                        placeholder="Enter email address"
                      />
                    </div>


                  </div>
                  <Link to="/" className="btn btn-md px-5 py-3 w-100 mt-2 btn-primary">
                    Login
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
